export default `
  query getSearchSortFields($search: String!) {
    products(search: $search, pageSize: 1, currentPage: 1) {
      sort_fields {
        default
        options {
          direction
          is_default
          label
          value
        }
      }
    }
  }
`;
